import type { SvgIconComponent } from "@mui/icons-material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CompressIcon from "@mui/icons-material/Compress";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import ExpandIcon from "@mui/icons-material/Expand";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import PercentIcon from "@mui/icons-material/Percent";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import WaterDropIcon from "@mui/icons-material/WaterDrop";

import { DashboardSortType } from "~/feature/dashboard/components/sortAndFilters/SortBy/types";
import type { IGetEventsAggregatedRequestParams } from "~/feature/dashboard/types";
import { EventSortByEnum } from "~/types/event";
import { SortOrderEnum } from "~/types/sort";

export const requestParamsByDashboardSortType: Record<
  DashboardSortType,
  IGetEventsAggregatedRequestParams
> = {
  [DashboardSortType.Volume24]: {
    sortBy: EventSortByEnum.VOLUME24,
    sortOrder: SortOrderEnum.DESC,
  },
  [DashboardSortType.TotalVolume]: {
    sortBy: EventSortByEnum.VOLUME,
    sortOrder: SortOrderEnum.DESC,
  },
  [DashboardSortType.Liquidity]: {
    sortBy: EventSortByEnum.LIQUIDITY,
    sortOrder: SortOrderEnum.DESC,
  },
  [DashboardSortType.Newest]: {
    sortBy: EventSortByEnum.START_DATE,
    sortOrder: SortOrderEnum.DESC,
  },
  [DashboardSortType.EndingSoon]: {
    sortBy: EventSortByEnum.END_DATE,
    sortOrder: SortOrderEnum.ASC,
  },
  [DashboardSortType.Consensus]: {
    sortBy: EventSortByEnum.CONSENSUS,
    sortOrder: SortOrderEnum.DESC,
  },
  [DashboardSortType.TightestSpread]: {
    sortBy: EventSortByEnum.SPREAD,
    sortOrder: SortOrderEnum.ASC,
  },
  [DashboardSortType.WidestSpread]: {
    sortBy: EventSortByEnum.SPREAD,
    sortOrder: SortOrderEnum.DESC,
  },
};

export const labelByDashboardSortType: Record<DashboardSortType, string> = {
  [DashboardSortType.Volume24]: "24hr Volume",
  [DashboardSortType.TotalVolume]: "Total Volume",
  [DashboardSortType.Liquidity]: "Liquidity",
  [DashboardSortType.Newest]: "Newest",
  [DashboardSortType.EndingSoon]: "Ending Soon",
  [DashboardSortType.Consensus]: "PH Consensus",
  [DashboardSortType.TightestSpread]: "Tightest spread",
  [DashboardSortType.WidestSpread]: "Widest spread",
};

export const iconByDashboardSortType: Record<
  DashboardSortType,
  SvgIconComponent
> = {
  [DashboardSortType.Volume24]: ShowChartIcon,
  [DashboardSortType.TotalVolume]: EqualizerIcon,
  [DashboardSortType.Liquidity]: WaterDropIcon,
  [DashboardSortType.Newest]: FiberNewIcon,
  [DashboardSortType.EndingSoon]: AccessTimeIcon,
  [DashboardSortType.Consensus]: PercentIcon,
  [DashboardSortType.TightestSpread]: CompressIcon,
  [DashboardSortType.WidestSpread]: ExpandIcon,
};
